// Stories index — reads post-B-117 user stories from `public.tickets`
// (type='user_story'). Replaces the legacy `public.stories` table.
// Groups by parent epic.

import { pageBoilerplateFetch } from '../../functions/tickets/ticketUtils.js'
import { fetchStoriesTree } from '../../functions/tickets/fetchEpicsTree.js'

export const stories = {
  extends: 'AppPage',
  metadata: { title: 'Stories / Tickets / Symbols Workspace' },

  fetch: pageBoilerplateFetch,

  onCreate: async (el, s) => {
    const tree = await fetchStoriesTree()
    s.root.update({ storiesTree: tree })
  },

  onRemove: (el) => {
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  TicketsStoriesMain: {},
  TicketsNewTicketModal: {},
  TicketsDetailModal: {}
}
